var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import client from "@irati/utils/services/apollo";
import sagaErrorHandler from "@irati/deals/services/errors/sagaErrorHandler";
import { DealsListType } from "@irati/types";
import PBService from "@irati/utils/services";
import fullSagaQuery, { withStockQuery as fullSagaWithStockQuery } from "./queries/GetSaga";
import fullPerksSaga from "./queries/fragments/fullPerksSaga";
import fullSagaStartMutation from "./mutations/SagaStart";
import fullSagaOrderMutation from "./mutations/SagaOrder";
import fullSagaUpdateMutation from "./mutations/SagaUpdate";
import fullSagaPayMutation from "./mutations/SagaPay";
import fullSagaCompleteMutation from "./mutations/SagaComplete";
import stockCount from "./queries/StockQuery";
var PerksSagaService = /** @class */ (function (_super) {
    __extends(PerksSagaService, _super);
    function PerksSagaService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PerksSagaService.prototype.get = function (uuid, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.forceRefetch, forceRefetch = _c === void 0 ? false : _c, _d = _b.stockCountForDealId, stockCountForDealId = _d === void 0 ? "" : _d;
        return __awaiter(this, void 0, Promise, function () {
            var fragmentName, cachedSaga, fetchPolicy, variables, query;
            return __generator(this, function (_e) {
                if (!forceRefetch && !stockCountForDealId) {
                    fragmentName = fullPerksSaga.definitions[0].name.value;
                    cachedSaga = client.readFragment({
                        id: "DealSaga@" + uuid,
                        fragment: fullPerksSaga,
                        fragmentName: fragmentName
                    });
                    if (cachedSaga) {
                        return [2 /*return*/, cachedSaga];
                    }
                }
                fetchPolicy = forceRefetch ? "network-only" : "cache-first";
                variables = { uuid: uuid, dealId: stockCountForDealId };
                query = stockCountForDealId ? fullSagaWithStockQuery : fullSagaQuery;
                return [2 /*return*/, client.query({ query: query, variables: variables, fetchPolicy: fetchPolicy }).then(function (_a) {
                        var data = _a.data;
                        return data.perksSaga;
                    })];
            });
        });
    };
    PerksSagaService.prototype.stockCount = function (dealId, _a) {
        var _b = (_a === void 0 ? {} : _a).forceRefetch, forceRefetch = _b === void 0 ? false : _b;
        var fetchPolicy = forceRefetch ? "network-only" : "cache-first";
        var variables = { dealId: dealId };
        return client.query({ query: stockCount, variables: variables, fetchPolicy: fetchPolicy }).then(function (_a) {
            var data = _a.data;
            var keyedStock = {};
            data.dealStockCount.stockTotals.forEach(function (value) {
                keyedStock[value.id] = value.count;
            });
            return __assign(__assign({}, data.dealStockCount), { stockTotals: keyedStock });
        });
    };
    PerksSagaService.prototype.start = function (deal, user) {
        var variables = {
            details: {
                dealId: deal.uuid,
                userId: user.uuid,
                isCompanyBenefit: deal.type === DealsListType.Company
            }
        };
        var sagaRequest = client.mutate({ mutation: fullSagaStartMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data.perksSagaStart;
        });
        // we always want stock counts when we start a saga
        var stockRequest = this.stockCount(deal.uuid);
        // Can't mix queries and mutations so must parallalise start saga + stock request
        return Promise.all([sagaRequest, stockRequest]).then(function (res) { return res[0]; });
    };
    PerksSagaService.prototype.order = function (saga, details) {
        var variables = {
            sagaId: saga.uuid,
            details: details
        };
        return client.mutate({ mutation: fullSagaOrderMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data.perksSagaOrder;
        });
    };
    PerksSagaService.prototype.update = function (saga, details) {
        var variables = {
            sagaId: saga.uuid,
            details: details
        };
        return client.mutate({ mutation: fullSagaUpdateMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data.perksSagaUpdate;
        });
    };
    PerksSagaService.prototype.pay = function (saga, payment) {
        var variables = {
            sagaId: saga.uuid,
            details: payment
        };
        return client.mutate({ mutation: fullSagaPayMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data.perksSagaPay;
        });
    };
    PerksSagaService.prototype.complete = function (saga) {
        var variables = {
            sagaId: saga.uuid
        };
        return client.mutate({ mutation: fullSagaCompleteMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data.perksSagaComplete;
        });
    };
    return PerksSagaService;
}(PBService));
var service = new PerksSagaService({ errorHandlers: [sagaErrorHandler] });
export default service;
